<template>
  <div>
    <v-card class="elevation-0 ">
      <v-card-title >
        <span class="pink--text font-weight-bold ">Education & Carrers</span>

        <v-spacer></v-spacer>
        <span  style="cursor: pointer;text-decoration: underline;"class="primary--text caption"
          @click="$emit('ShowEdit')">
          Edit <v-icon small>mdi-chevron-right</v-icon> </span>
      </v-card-title>
      <v-divider class=""></v-divider>
      <v-row  no-gutters>
        <v-col lg="5" sm="5" md="5" cols="12">
          <v-row no-gutters>
            <v-col>
              <v-row no-gutters>
                <v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                  Highest Qualification
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.qualifications}}
                  <!-- {{ $store.getters.handleEmptyString(userProfile.qualification) }}  -->
<!-- {{  checkprofileCompleted(userProfile.qualification,profileDetails?.qualification,clientprofile) }} -->

                </v-col>
                <v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                  Annual Income
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.annualIncome}}

                  <!-- {{ $store.getters.handleEmptyString(userProfile.annualIncome) }}  -->
<!-- {{  checkprofileCompleted(userProfile.annualIncome,profileDetails?.annualIncome,clientprofile) }} -->

                </v-col>

              </v-row>

            </v-col>
          </v-row>
        </v-col>
        <!-- <v-col class="d-flex align-center" lg="1" > -->
          <v-divider vertical class="highlighted-divider mr-2"></v-divider>
        <!-- </v-col> -->
        <v-col lg="5" sm="5" md="5" cols="12">
          <v-row no-gutters>
            <v-col>
              <v-row no-gutters>
                  <v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                    Working With
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.employmentType}}

                  <!-- {{ $store.getters.handleEmptyString(userProfile.workingWith) }}  -->
<!-- {{  checkprofileCompleted(userProfile.workingWith,profileDetails?.workingWith,clientprofile) }} -->

                </v-col><v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                  Working As
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.profession}}

                  <!-- {{ $store.getters.handleEmptyString(userProfile.workingAs) }}  -->
<!-- {{  checkprofileCompleted(userProfile.workingAs,profileDetails?.workingAs,clientprofile) }} -->

                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
       
      </v-row>
    </v-card>
    <v-divider class="mt-1"></v-divider>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Your data here
    };
  },
  props:{
       partnerpreference:{}
    }
};
</script>

<style>
/* .info-text {
  font-size: 16px;
  color: #666;
  font-weight: 500;
} */

 .highlighted-divider {
  border: 2px solid #ff6061;
  /* Highlight color */
} 

/* .v-card-title {
  background-color: #f6bbd0;
  padding: 16px;
  border-radius: 6px;
} */

/* .pa-6 {
  padding: 16px !important;
} */

/* .elevation-2 {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
} */
</style>